import { ruleRunner } from 'validations/ruleRunner';
import { required, isEmail, minimun, hasNoValue } from 'validations/rules';

const Validations = (minimumCommissionValue = '0.01') => {
  return [
    ruleRunner('email', 'e-mail do parceiro', required, isEmail),
    ruleRunner('comission_value', 'porcentagem', hasNoValue('action', 'remove', minimun(minimumCommissionValue))),
  ];
};

export default Validations;
